export enum SplitStatusEnum {
  CREATED = "CREATED",
  FINANCIAL_ANALYSIS = "FINANCIAL_ANALYSIS",
  FINANCIAL_APPROVED = "FINANCIAL_APPROVED",
  FINANCIAL_REJECTED = "FINANCIAL_REJECTED",
  CONTRACT_SENT = "CONTRACT_SENT",
  CONTRACT_SIGNED = "CONTRACT_SIGNED",
  SPLIT_APPROVED = "SPLIT_APPROVED",
  CADASTRO_REJECTED = "CADASTRO_REJECTED",
  CANCELLED_EXPIRED = "CANCELLED_EXPIRED",
}

export const SplitStatusLabels: Record<SplitStatusEnum, string> = {
  [SplitStatusEnum.CREATED]: "Solicitação de split criada",
  [SplitStatusEnum.FINANCIAL_ANALYSIS]: "Em análise (Financeiro)",
  [SplitStatusEnum.FINANCIAL_APPROVED]:
    "Aprovado pelo Financeiro → Encaminhado ao Cadastro",
  [SplitStatusEnum.FINANCIAL_REJECTED]: "Recusado pelo Financeiro",
  [SplitStatusEnum.CONTRACT_SENT]: "Contrato enviado ao cliente",
  [SplitStatusEnum.CONTRACT_SIGNED]: "Contrato assinado pelo cliente",
  [SplitStatusEnum.SPLIT_APPROVED]: "Split aprovado e registrado",
  [SplitStatusEnum.CADASTRO_REJECTED]: "Recusado pelo Cadastro",
  [SplitStatusEnum.CANCELLED_EXPIRED]:
    "Cancelado por expiração do prazo (10 dias úteis)",
};

export const SplitStatusColors: Record<SplitStatusEnum, string> = {
  [SplitStatusEnum.CREATED]: "gray",
  [SplitStatusEnum.FINANCIAL_ANALYSIS]: "yellow",
  [SplitStatusEnum.FINANCIAL_APPROVED]: "blue",
  [SplitStatusEnum.FINANCIAL_REJECTED]: "red",
  [SplitStatusEnum.CONTRACT_SENT]: "purple",
  [SplitStatusEnum.CONTRACT_SIGNED]: "green",
  [SplitStatusEnum.SPLIT_APPROVED]: "teal",
  [SplitStatusEnum.CADASTRO_REJECTED]: "red",
  [SplitStatusEnum.CANCELLED_EXPIRED]: "orange",
};

export interface TimelineItem {
  status: SplitStatusEnum;
  description: string;
  timestamp: string;
  completed: boolean;
  inProgress?: boolean;
  rejected?: boolean;
  reason?: string;
  changedBy?: string;
  pending?: boolean;
}

/** Timeline agrupada por tentativa: { "0": [...], "1": [...] }. */
export type SplitTimelineMap = Record<string, TimelineItem[]>;
